<script>
import Layout from "@layouts/main-fluid";
import CrudTable from "@components/CrudTable";

export default {
  props: {
    name: {
      type: String,
      default: ""
    },
    table: {
      type: String,
      default: ""
    },
    fields: {
      type: Array,
      default: () => {
        return [];
      }
    },
    filter: {
      type: String,
      default: ""
    },
    include: {
      type: String,
      default: ""
    },
    filtrarAtivo:{
      type: Boolean,
      default: false
    }
  },
  components: { Layout, CrudTable },
  data() {
    return {
      title: this.name,
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: this.name,
          href: `"/${this.table}`,
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items" :alertVisible="false">
    <div class="page-content">
      <CrudTable
        :name="name"
        :table="table"
        :fields="fields"
        :filter="filter"
        :include="include"
        :filtrarAtivo="filtrarAtivo"
      />
    </div>
  </Layout>
</template>
